import { useState, useRef, useEffect } from "react";

export function BeyondProfitSelector({ t, beyondProfitSelections, setBeyondProfitSelections, isMobile }: any) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const tooltipRef = useRef(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (tooltipRef.current && !(tooltipRef.current as any).contains(e.target)) setTooltipOpen(false);
    };
    if (tooltipOpen) document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [tooltipOpen]);

  return (
    <div style={{ width: "100%", marginBottom: 16 }}>
      <div style={{ padding: "16px 20px", border: "1px solid #e0e0e0", borderRadius: 2 }}>

        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
          <span style={{ fontFamily: "'Courier New', monospace", fontSize: 11, fontWeight: 900, letterSpacing: "0.15em", color: "#000" }}>
            {t.beyondProfit}
          </span>

          <div ref={tooltipRef} style={{ position: "relative", display: "inline-flex" }}>
            <button
              onClick={() => setTooltipOpen(o => !o)}
              style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 16, height: 16, borderRadius: "50%", border: tooltipOpen ? "1px solid rgba(255,255,255,0.5)" : "1px solid #bbb", background: tooltipOpen ? "#000" : "transparent", color: tooltipOpen ? "#fff" : "#888", fontFamily: "'Courier New', monospace", fontSize: 9, fontWeight: 900, cursor: "pointer", lineHeight: 1, padding: 0, transition: "all 0.15s", flexShrink: 0 }}
              aria-label="More information"
            >
              i
            </button>
            {tooltipOpen && (
              <div style={{ position: "absolute", top: "calc(100% + 8px)", left: "50%", transform: "translateX(-50%)", background: "#fff", border: "1px solid #000", borderRadius: 2, padding: "12px 16px", width: 280, zIndex: 200, boxShadow: "0 4px 20px rgba(0,0,0,0.12)" }}>
                <div style={{ position: "absolute", top: -6, left: "50%", width: 10, height: 10, background: "#fff", border: "1px solid #000", borderBottom: "none", borderRight: "none", transform: "translateX(-50%) rotate(45deg)" }} />
                <div style={{ fontFamily: "'Courier New', monospace", fontSize: 10, color: "#333", lineHeight: 2, margin: 0, letterSpacing: "0.03em" }}>
                  {Object.keys(t.bpDefinitions || {}).map(key => (
                    <div key={key} style={{ borderBottom: "1px solid #f0f0f0", paddingBottom: 4, marginBottom: 4 }}>
                      {t.bpDefinitions[key]}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <span style={{ fontFamily: "'Courier New', monospace", fontSize: 9, color: "#888", fontWeight: 700, letterSpacing: "0.08em", marginLeft: 2 }}>
            {t.tokensPer || "1 TOKEN PER"}
          </span>
        </div>

        <div style={{ display: "flex", gap: isMobile ? 8 : 20, flexWrap: "nowrap", alignItems: "center", overflowX: "auto" }}>
          {Object.keys(t.bpOptions).map(opt => {
            const isChecked = beyondProfitSelections.includes(opt);
            return (
              <label key={opt} style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", userSelect: "none" }}
                onClick={() => setBeyondProfitSelections((prev: string[]) => isChecked ? prev.filter(o => o !== opt) : [...prev, opt])}>
                <div style={{ width: 16, height: 16, border: isChecked ? "2px solid #000" : "2px solid #ccc", background: isChecked ? "#000" : "#fff", borderRadius: 2, display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.15s", flexShrink: 0 }}>
                  {isChecked && <span style={{ color: "#fff", fontSize: 10, lineHeight: 1 }}>✓</span>}
                </div>
                <span style={{ fontFamily: "'Courier New', monospace", fontSize: 11, fontWeight: isChecked ? 900 : 400, color: isChecked ? "#000" : "#888", letterSpacing: "0.06em", transition: "all 0.15s" }}>
                  {t.bpOptions[opt]}
                </span>
              </label>
            );
          })}
        </div>

      </div>
    </div>
  );
}
